module.exports = __webpack_public_path__ + "img/d52488b.jpg";